import { FormGroup } from '@angular/forms';
import { AgencyLookupDetail } from '../../shared/models/agency-lookup-detail';
import { AgencyLookupStore } from '../../shared/lookup/agency-lookup/agency-lookup.store';

export class AgencyLookupConverter {

  static updateFormFields(detail: AgencyLookupDetail,
                          contactLookupForm: FormGroup,
                          agencyLookupStore: AgencyLookupStore) {

    contactLookupForm.patchValue({
      name: detail.name,
      line1: detail.address.line1,
      line2: detail.address.line2,
      city: detail.address.city,
      state: detail.address.state,
      postalCode: detail.address.postalCode,
      agencyId: detail.agencyId
    });
    contactLookupForm.controls[ 'contact' ].patchValue({
      firstName: detail.contact.firstName,
      lastName: detail.contact.lastName,
      email: detail.contact.email,
      phone: detail.contact.phone,
      fax: detail.contact.fax
    });

    agencyLookupStore.clearSearchResults();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/agency-lookup-converter.ts